'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _addCommas = require('add-commas');

var _addCommas2 = _interopRequireDefault(_addCommas);

var _hierarchyClassDescriptionById = require('./hierarchy/class-description-by-id');

var _hierarchyClassDescriptionById2 = _interopRequireDefault(_hierarchyClassDescriptionById);

var _isSearchResultsPath = require('./is-search-results-path');

var _isSearchResultsPath2 = _interopRequireDefault(_isSearchResultsPath);

var auDefaultDescription = 'SEEK is Australia\'s number one jobs site. Search or browse jobs across Australia. Find work or recruit the ideal candidate.  SEEK and you shall find.';
var nzDefaultDescription = 'Job Search on SEEK - New Zealand\'s number one employment site. Search jobs across New Zealand. Find work or recruit the ideal candidate.  SEEK and you shall find.';

var isTruthy = function isTruthy(x) {
  return x;
};
var first = function first(array) {
  return array.slice(0, 1);
};

var pluralise = function pluralise(count, word) {
  return (0, _addCommas2['default'])(count) + ' ' + word + (count !== 1 ? 's' : '');
};

var commaSeparated = function commaSeparated() {
  for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  return items.filter(isTruthy).join(', ');
};

var getLocationDescription = function getLocationDescription(location) {
  return location.type !== 'Location' ? location.description : commaSeparated(location.locationDescription, location.stateDescription);
};

var getClassDescription = function getClassDescription(classification, subclassification) {
  var classIds = classification.split(',');
  var subClassIds = subclassification.split(',');

  var firstIds = [].concat(_toConsumableArray(first(classIds)), _toConsumableArray(first(subClassIds)));
  var classNames = firstIds.map(_hierarchyClassDescriptionById2['default']).filter(isTruthy).join(', ');

  var classificationCount = classIds.length + subClassIds.length;
  var classRemainder = classificationCount <= 2 ? '' : ' & ' + pluralise(classificationCount - 2, 'more classification');

  return '' + classNames + classRemainder;
};

var getCountDescription = function getCountDescription(count) {
  return count === 0 ? null : 'with ' + pluralise(count, 'job') + ' found';
};

var getSearchMetaDescription = function getSearchMetaDescription(_ref) {
  var _ref$totalCount = _ref.totalCount;
  var totalCount = _ref$totalCount === undefined ? 0 : _ref$totalCount;
  var _ref$query = _ref.query;
  var query = _ref$query === undefined ? {} : _ref$query;
  var _ref$location = _ref.location;
  var location = _ref$location === undefined ? {} : _ref$location;
  var _query$classification = query.classification;
  var classification = _query$classification === undefined ? '' : _query$classification;
  var _query$subclassification = query.subclassification;
  var subclassification = _query$subclassification === undefined ? '' : _query$subclassification;

  var classDescription = getClassDescription(classification, subclassification);
  var locationDescription = getLocationDescription(location);

  var descriptionBody = ['Find your ideal job at SEEK', getCountDescription(totalCount), classDescription ? 'for ' + classDescription : null, locationDescription ? 'in ' + locationDescription : null].filter(isTruthy).join(' ');

  return descriptionBody + '. View all our vacancies now with new jobs added daily!';
};

exports['default'] = function (_ref2) {
  var _ref2$locale = _ref2.locale;
  var locale = _ref2$locale === undefined ? 'au' : _ref2$locale;
  var _ref2$path = _ref2.path;
  var path = _ref2$path === undefined ? '/jobs' : _ref2$path;

  var restArgs = _objectWithoutProperties(_ref2, ['locale', 'path']);

  if ((0, _isSearchResultsPath2['default'])(path)) {
    return getSearchMetaDescription(_extends({}, restArgs));
  }

  return locale.toLowerCase() === 'au' ? auDefaultDescription : nzDefaultDescription;
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/get-meta-description.js
 ** module id = 553
 ** module chunks = 0
 **/